import React from 'react';
import { I18n } from '@aws-amplify/core';
import { FormItemWrapper, LabelMediumRegular } from '@/components/Settings/DataExtraction/styles';
import * as S from './styles';

export function InitialDateFormItem(): JSX.Element {
	return (
		<FormItemWrapper
			name="start_date"
			label={<LabelMediumRegular>{I18n.get('Initial date')}</LabelMediumRegular>}
			labelCol={{ span: 24 }}
		>
			<S.CustomDatePicker
				format="L"
				placeholder={I18n.get('Initial date')}
				disabledDate={(currentDate) => currentDate && currentDate.valueOf() > Date.now()}
			/>
		</FormItemWrapper>
	);
}
